export default __webpack_public_path__ + "static/media/vcall.6508cd53.svg";